import { IAccessCode } from "../../../pages/AccessCode/interfaces";

class AccessCodeMapper {

    toDomain(persistenceAccessCode: any): IAccessCode {
        return {
            id: persistenceAccessCode.id,
            code: persistenceAccessCode.code,
            type: persistenceAccessCode.type,
            app_user: {
                id: persistenceAccessCode.appUser.id,
                phone: persistenceAccessCode.appUser.phone,
                name: persistenceAccessCode.appUser.name,
                cpf: persistenceAccessCode.appUser.cpf,
                counties: persistenceAccessCode.appUser.counties.map((county: any) => ({
                    id: county.id,
                    name: county.name,
                })),
            },
            created_at: persistenceAccessCode.createdAt,
        }
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new AccessCodeMapper();
